module.exports = __webpack_public_path__ + "img/revenues-types.12a72d28.svg";